import React from 'react';
import { Button } from './ui/button';
import { heroData } from '../data/mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center bg-[#0d0d0d] overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src={heroData.backgroundImage}
          alt="Gym environment"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent opacity-90"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[87.5rem] mx-auto px-5 md:px-10 py-32 md:py-40">
        <div className="max-w-[15ch]">
          <h1 className="font-['Bebas_Neue'] font-black text-[clamp(4rem,8vw,8rem)] leading-[0.76] text-white mb-6">
            Your Transformation
            <br />
            <span className="text-[#e8ff47]">DESERVES</span>
            <br />
            To Be Seen.
          </h1>

          <p className="font-['DM_Sans'] text-[#dfddd6] text-lg md:text-xl leading-relaxed mb-10 max-w-[50ch]">
            India's gym content creation campaign. Professional reels, photos, and transformation content — shoot inside your actual gym.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Button 
              onClick={() => scrollToSection('pricing')}
              className="bg-[#e8ff47] text-[#0d0d0d] hover:opacity-90 hover:scale-105 rounded-full px-8 py-6 font-['DM_Sans'] font-semibold text-base uppercase tracking-tight transition-all"
            >
              View Packages
            </Button>
            <Button 
              onClick={() => scrollToSection('process')}
              variant="outline"
              className="border-2 border-[#e8ff47] text-[#e8ff47] bg-transparent hover:bg-[#e8ff47] hover:text-[#0d0d0d] hover:scale-105 rounded-full px-8 py-6 font-['DM_Sans'] font-semibold text-base uppercase tracking-tight transition-all"
            >
              How It Works
            </Button>
          </div>

          {/* Stats Bar */}
          <div className="flex flex-wrap gap-8">
            {heroData.stats.map((stat, index) => (
              <div key={index} className="flex flex-col">
                <span className="font-['Bebas_Neue'] text-[#e8ff47] text-3xl md:text-4xl">
                  {stat.value}
                </span>
                <span className="font-['DM_Sans'] text-[#888680] text-sm uppercase tracking-wider">
                  {stat.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
